import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ui from 'config-app/ui';
import { sanitize } from 'dompurify';

// 製品例

export const Page1 = () => {
  // GA イベントトラッキング送信済みかどうか
  const [isGaSent, setIsGaSent] = useState(false);

  const products = window.product;
  const labels = window.theme;
  const variants = products.variants;

  // 会員特典対象商品
  const { offers_for_members } = products;
  const offersForMembers = offers_for_members && offers_for_members.product_tags ? offers_for_members : null;
  // 対象と対象外のテキスト設定
  let offersForMembersMessage = null;
  if (offersForMembers) {
    const { product_tags, tag_name, message } = offersForMembers;
    // product_tags 配列に tag_name の値が含まれていれば、対象商品
    const isEligible = product_tags.filter((tag) => tag === tag_name).length > 0;
    offersForMembersMessage = isEligible ? message.eligible : message.not_eligible;
  }

  // 選べるギフト対象商品
  const { selectable_gift } = products;
  const selectableGift = selectable_gift && selectable_gift.product_tags ? selectable_gift : null;
  let isSelectableGift = false;
  if (selectableGift) {
    const { product_tags, tag_name } = selectableGift;
    isSelectableGift = product_tags.filter((tag) => tag === tag_name).length > 0;
  }
  const anyGiftButtonClassName = isSelectableGift ? 'txt isSelectableGift' : 'txt';

  let wglang = localStorage.getItem('wglang');
  if(!wglang){
      wglang = window.theme.defaultWglang;
  }

   // 戻るリンクの初期化
  var url = labels.urlForProduct.replace(/\{wglang\}/g,wglang);
  useEffect(() => {
    let successHistoryBack = false;
    window.addEventListener('unload',()=>{
      successHistoryBack = true;
    });
    window.addEventListener('beforeunload',()=>{
      successHistoryBack = true;
    });
    // 同ドメインから遷移したかどうか
    var isSameDomain = false;
    var matches = document.referrer.match(/https?:\/\/([^\/]+).*/);
    if(document.referrer && matches && 1 < matches.length){
      const domain = matches[1].replace('store.','').replace('bengal.','').replace('www.','');
      isSameDomain = -1 < window.location.hostname.indexOf(domain);
    }
    // 同ドメインから遷移してきた場合、戻るボタンはhistory.backで遷移
    if(isSameDomain) {
    var i;
    var aReturn = document.querySelectorAll(".return");
    for (i = 0; i < aReturn.length; i++) {
        aReturn[i].addEventListener("click", function (e) {
            e.preventDefault();
            window.history.back();
            setTimeout(()=>{
              if(!successHistoryBack){
                  window.location.href = document.referrer ? document.referrer : e.target.href;
              }
            },200);
        });
      }
    }
  });

  // バリエーションが4つ以上ある場合のレイアウト調整用
  let isOver4products = false;
  if (variants.length >= 4) {
    isOver4products = true;
  }

  // GA イベントトラッキング
  const handleGaAddToCart = (e, id) => {
    // e.preventDefault();
    if (isGaSent) return;
    // グローバルで定義されたトラッキング関数を実行
    if (window.addToCart) {
      window.addToCart(id.sku);
      setIsGaSent(true);
    }
  }

  return (
    <Container>
      <PdtList>
        {variants.map (item => <PdtItem key={variants}>
          <Img>
            <img src={item.image} />
          </Img>
          <Txt>
            <PdtName>{products.title}</PdtName>
            <PdtNum>{item.sku}</PdtNum>
            <PdtColor>{Object.keys([products.values]).length >= 1 && item.options}</PdtColor>
            <PdtPrice className={item.wc_discount_rate > 0 && "member"}>
              <div className="pdtPrice">
                {item.wc_discount_rate > 0 && <div className="priceLabel">{labels.regular_price}</div>}
                <div className="em">
                  <div className="currencySymbol">{labels.price_prefix}</div>
                  <div className="number">{window.theme.moneyFormat.replace(/{{amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator|_with_apostrophe_separator)?}}/g,Number(item.price.toString().replace(/[^0-9\.]+/g,'')).toLocaleString())}</div>
                </div>
                <div className="unit">{labels.price_suffix}</div>
                <div className="tax">{labels.tax_included}</div>
              </div>
            </PdtPrice>
            {item.wc_discount_rate > 0 &&
            <PdtPrice>
            <div className="pdtPrice">
              <div className="em">
                <div className="currencySymbol">{labels.price_prefix}</div>
                <div className="number">{window.theme.moneyFormat.replace(/{{amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator|_with_apostrophe_separator)?}}/g,Number(item.wc_discounted_price.toString().replace(/[^0-9\.]+/g,'')).toLocaleString())}</div>
              </div>
              <div className="unit">{labels.price_suffix}</div>
              <div className="tax">{labels.tax_included}</div>
            </div>
            <span className="label">{labels.discountFormat.replace(/{{rate}}/ ,(Math.round(Number(item.wc_discount_rate)*100)).toString())}</span>
            </PdtPrice>}
            {offersForMembersMessage &&
              <div
                className='offersForMembers'
                dangerouslySetInnerHTML={{ __html: sanitize(offersForMembersMessage) }}
              />
            }
            {item.inventory_quantity <= 0 && item.inventory_policy === "continue" && item.next_incoming_date !== "" && <Note><p className="notice">{item.next_incoming_date_label}</p><p className="notes">{labels.strings["preOrderNote"]}</p></Note>}
            {(() => {
              if (item.inventory_quantity > 0) {
                return (
                <Btn>
                  <form method="post" action="/cart/add" onSubmit={(e) => handleGaAddToCart(e, item)}>
                    <input type="hidden" name="id" value={item.id} />
                    <input type="hidden" name="quantity" value="1" />
                    <button className={anyGiftButtonClassName} data-anygift="add-to-cart">{labels.strings["addToCart"]}</button>
                  </form>
                </Btn>
                )
              } else {
                if(item.inventory_policy === 'continue'){
                  if(item.next_incoming_date !== ''){
                    return (
                      <Btn>
                        <form method="post" action="/cart/add" onSubmit={(e) => handleGaAddToCart(e, item)}>
                          <input type="hidden" name="id" value={item.id} />
                          <input type="hidden" name="quantity" value="1" />
                          <button className={anyGiftButtonClassName} data-anygift="add-to-cart">{labels.strings["preOrder"]}</button>
                        </form>
                      </Btn>
                    )
                  } else {
                      return (
                      <Btn>
                        <form method="post" action="/cart/add" onSubmit={(e) => handleGaAddToCart(e, item)}>
                          <input type="hidden" name="id" value={item.id} />
                          <input type="hidden" name="quantity" value="1" />
                          <button className={anyGiftButtonClassName} data-anygift="add-to-cart">{labels.strings["addToCart"]}</button>
                        </form>
                      </Btn>
                    )
                  }
                } else {
                    return (
                    <Btn className="disabled">
                      <button className={anyGiftButtonClassName} data-anygift="add-to-cart">{labels.strings["soldOut"]}</button>
                    </Btn>
                  )
                }
              }
            })()}
          </Txt>
        </PdtItem>)}
      </PdtList>
      <Shipping>
        <div>
          <p>{labels.shipping_cost_note1}</p>
          <p className="shippingNote">{labels.shipping_cost_note2}</p>
        </div>
      </Shipping>
      <BackBtn>
        <a href={url} className="return"><svg className="icon" xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16">
  <path id="_" data-name=">" d="M8,0,1.7,8,8,16,6.3,16,0,8,6.3,0Z" transform="translate(0 0)" fill="#333"></path></svg>{labels.back}</a></BackBtn>
    </Container>
  );
};

const Container = styled.div`
  > *:last-child {
    margin-bottom: 0 !important;
  }
  p, ul {
    line-height: 1.5;
  }
  ${ui.MQ_MD_LG} {
    width: 1400px;
    margin: 0 auto;
    padding: 168px 0 200px;
  }
  ${ui.MQ_XS_SM} {
    margin: 0 30px;
    padding: 105px 0 100px;
  }
`
const PdtList = styled.ul`
  line-height: 1.5;
  ${ui.MQ_MD_LG} {
    width: 1160px;
    margin: 0 auto 50px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
  }
  ${ui.MQ_XS_SM} {
    margin-bottom: 30px;
  }
`;

const PdtItem = styled.li`
  box-sizing: border-box;
  border: 1px solid #D7D7D7;
  text-align: left;
  ${ui.MQ_MD_LG} {
    width: calc((100% - 80px) / 3);
    padding: 20px 0 40px;
    flex: 0;
    &:not(:nth-child(3n+1)){
        margin-left: 40px;
    }
    &:nth-child(n+4) {
      margin-top: 40px;
    }
  }
  ${ui.MQ_XS_SM} {
    padding: 15px 0 25px;
    + li{
      margin-top: 20px;
    }
  }
  `
  ;

const Img = styled.div`
  text-align: center;
  padding: 40px 0 36px;
  ${ui.MQ_MD_LG} {
    img {
      width: 240px;
    }
  }
  ${ui.MQ_XS_SM} {
    padding: 20px 0 17px;
    img {
      width: 120px;
    }
  }
`;

const Txt = styled.div `
  .offersForMembers {
    font-size: 0.9em;
  }
  ${ui.MQ_MD_LG} {
    margin: 0 30px;
    .offersForMembers {
      margin-bottom: 21px;
    }
  }
  ${ui.MQ_XS_SM} {
    margin: 0 20px;
    .offersForMembers {
      margin-bottom: 16px;
    }
  }
`;

const PdtName = styled.div`
  font-weight: 500;
  ${ui.MQ_MD_LG} {
    font-size: 2.4rem;
    margin-bottom: 12px;
  }
  ${ui.MQ_XS_SM} {
    font-size: 1.6rem;
    margin-bottom: 7px;
  }
`;

const PdtNum = styled.div`
  ${ui.MQ_MD_LG} {
    font-size: 18px;
    margin-bottom: 5px;
  }
  ${ui.MQ_XS_SM} {
    font-size: 14px;
    margin-bottom: 3px;
  }
`;

const PdtColor = styled.div`
  font-weight: bold;
  ${ui.MQ_MD_LG} {
    font-size: 18px;
    margin-bottom: 10px;
  }
  ${ui.MQ_XS_SM} {
    font-size: 14px;
    margin-bottom: 5px;
  }
`;

const PdtPrice = styled.div`
  .pdtPrice {
    font-weight: bold;
    margin-right: -2px;
    display: inline-block;
    div {
      display: inline-block;
    }
    .tax {
      font-weight: normal;
      margin-left: 3px;
    }
  }
  &.member {
    .pdtPrice {
      font-weight: normal;
      .em {
        margin-left: 3px;
        .currencySymbol,
        .number {
          text-decoration: line-through;
        }
      }
    }
  }
  .label {
    display: inline-block;
    background: #004EA2;
    color: #fff;
    font-weight: bold;
    margin-left: 1em;
  }
  ${ui.MQ_MD_LG} {
    font-size: 1.6rem;
    // margin-bottom: 21px;
    &.member {
      margin-bottom: 5px;
      .pdtPrice {
        .em {
          font-size: 1.8rem;
        }
        .tax {
          font-size: 1.6rem;
        }
      }
    }
    .pdtPrice {
      font-size: 1.8rem;
      .em {
        font-size: 3rem;
      }
    }
    .label {
      font-size: 1.4rem;
      padding: 5px 11px;
      vertical-align: 20%;
    }
  }
  ${ui.MQ_XS_SM} {
    margin-bottom: 6px;
    font-size: 1.3rem;
    &.member {
      margin-bottom: 1px;
      .pdtPrice {
        .em {
          font-size: 1.3rem;
        }
      }
    }
    .pdtPrice {
      .em{
        font-size: 1.6rem;
      }
    }
    .label {
      font-size: 1.1rem;
      padding: 1px 7px 2px;
    }
  }
`;

const Note = styled.p `
  .notice{
    font-weight: bold;
    color: #004EA2;
  }
  ${ui.MQ_MD_LG} {
    .notice{
      font-size: 1.8rem;
      margin-bottom: 6px;
    }
    .notes{
      font-size: 1.2rem;
      margin: 0 0 10px;
    }
  }
  ${ui.MQ_XS_SM} {
    .notice {
      font-size: 1.3rem;
    }
    .notes{
      font-size: 1rem;
    }
  }
`;

const Btn = styled.div`
  display: inline-block;
  .txt{
    display: block;
    text-decoration: none;
    font-weight: normal;
    box-sizing: border-box;
    border-color: #333;
    border-width: 1px;
    border-style: solid;
    position: relative;
    cursor: pointer;
    background: #333;
    color: #fff;
    font-weight: bold;
    transition: opacity 0.3s;
    &:hover{
      opacity: 0.8;
    }
  }
  .txt.isSelectableGift {
    opacity: 0;
  }
  &.disabled .txt {
    pointer-events: none;
    background: #D7D7D7;
    color: #888;
    border-color: #D7D7D7;
  }
  ${ui.MQ_MD_LG} {
    .txt {
      min-width: 300px;
      font-size: 1.8rem;
      padding: 16px 10px;
    }
  }
  ${ui.MQ_XS_SM} {
    width: 100%;
    .txt{
      width: 100%;
      font-size: 1.3rem;
      padding: 14px 10px;
    }
  }
`;

const Shipping = styled.div `
  line-height: 1;
  text-align: center;
  & > div {
    display: inline-block;
  }
  p {
    text-align: left;
    margin: 0;
  }
  ${ui.MQ_MD_LG} {
    margin: 40px auto 0;
    p {
      font-size: 16px;
    }
    .shippingNote {
      font-size: 14px;
    }
  }
  ${ui.MQ_XS_SM} {
    p {
      font-size: 13px;
    }
    .shippingNote {
      font-size: 11px;
    }
  }
`

const BackBtn = styled.div `
  text-decoration: none;
  transition: opacity 0.3s;
  text-align: center;
  a {
    text-decoration: none;
  }
  &:hover{
    opacity: 0.8;
  }
  .icon {
    margin-right: 10px;
  }
  ${ui.MQ_MD_LG} {
  margin-top: 40px;
    .icon {
      vertical-align: -10%;
    }
  }
  ${ui.MQ_XS_SM} {
  margin-top: 30px;
    .icon {
      transform: scale(.85);
      vertical-align: -20%;
    }
  }
`;
